// extracted by mini-css-extract-plugin
module.exports = {"desktopImg":"Modal_desktopImg__4ZXLl","mobileImg":"Modal_mobileImg__A3dw8","modal":"Modal_modal__w8Blv","overlay":"Modal_overlay__lX1Uv"};